angular
    .module('tradersyard')
    .filter('insecureUrl', [
        '$sce',
        function ($sce) {
            /**
             * Thankfully, all (as of now) URLs go through this filter.
             * In order to be GDPR compliant we can't embed YouTube videos from a regular domain.
             * YouTube offers enchanted privacy (no cookie will be set) if you switch the domain
             * from youtube.com to youtube-nocookie.com
             */
            return function (url) {
                if (!angular.isString(url)) return null;
                url = url.replace(/youtube.com\/embed/g, 'youtube-nocookie.com/embed');
                return $sce.trustAsResourceUrl(url);
            };
        },
    ])
    .filter('switch', function () {
        return function (input, map, def) {
            return map[input] || def || '';
        };
    })
    .filter('aduration', [
        function () {
            return function (data, measure) {
                var duration = moment.duration(data, measure ? measure : 'seconds');
                return (
                    duration.days() +
                    'd ' +
                    duration.hours() +
                    'h ' +
                    duration.minutes() +
                    'm ' +
                    duration.seconds() +
                    's'
                );
            };
        },
    ])
    .filter('markdown', [
        '$showdown',
        '$sce',
        '$sanitize',
        '$location',
        function ($showdown, $sce, $sanitize, $location) {
            return function (data) {
                if (typeof data !== 'string' || !data) {
                    return data;
                }

                $showdown.setOption('excludeTrailingPunctuationFromURLs', true);
                $showdown.setOption('simplifiedAutoLink', true);
                $showdown.setOption('simpleLineBreaks', true);
                $showdown.setOption('literalMidWordUnderscores', true);
                $showdown.setOption('strikethrough', true);

                function redir(url) {
                    return encodeURI(url).replace(/#/g, '%23');
                }

                var html = $sanitize(
                    $showdown.makeHtml(
                        data.replace(/(^|[\s]+)(\B\#\w\w+\b)($|[\s]+)/g, function (match, contents, offset, s) {
                            return match.replace(/(\B\#\w\w+\b)/g, function (match, contents, offset, s) {
                                return (
                                    '[' +
                                    contents +
                                    '](//' +
                                    $location.host() +
                                    '/search?q=' +
                                    redir(contents) +
                                    '#post)'
                                );
                            });
                        })
                    )
                );

                var element = angular.element(document.createElement('div'));

                element.html(html);

                angular.forEach(element.find('img'), function (img) {
                    img = angular.element(img);

                    var a = angular.element(document.createElement('a'));

                    a.attr('href', img.attr('src'));

                    a.text(img.attr('src'));

                    img.replaceWith(a);
                });

                angular.forEach(element.find('a'), function (a) {
                    angular.element(a).attr({
                        target: '_blank',
                        rel: 'nofollow',
                    });
                });

                return $sce.trustAsHtml(element.html());
            };
        },
    ])
    .filter('offset', function () {
        return function (input, start) {
            return input.slice ? input.slice(start) : [];
        };
    })
    .filter('ucFirst', function () {
        return function (data) {
            var f = data.charAt(0).toUpperCase();

            return f + data.substr(1, data.length - 1);
        };
    })
    .filter('thumb', function () {
        return function (url, x, y) {
            // support S3 image-filter urls
            if (url && url.includes('/s3-proxy/')) {
                return url.replace('/s3-proxy/', `/s3-proxy/${x}x${y}/`);
            }
            return url ? url.replace(/(\.[\w\d_-]+)(\?.*|)$/i, '-' + x + 'x' + y + '$1') : undefined;
        };
    })
    .filter('moment', [
        function () {
            return function (data, format) {
                switch (format) {
                    case 'smart':
                        var date = moment(data);
                        var diff = moment().diff(date, 'hours');
                        return diff > 5 ? date.calendar() : date.fromNow();

                    default:
                        return moment(data).format(format);
                }
            };
        },
    ])
    .filter('humanizeRating', function () {
        return function humanize(number) {
            var minusCondition = number < 0;
            if (number < 1000 && number > -1000) {
                if (number < 10 && number > -10) {
                    return Number(number.toFixed(2));
                } else if (number < 100 && number > -100) {
                    return Number(number.toFixed(1));
                } else {
                    return number.toFixed(0);
                }
            }
            number = Math.abs(number);
            var si = ['K', 'M', 'G', 'T', 'P', 'H'];
            var exp = Math.floor(Math.log(number) / Math.log(1000));
            var result = number / Math.pow(1000, exp);
            result = result % 1 > 1 / Math.pow(1000, exp - 1) ? result.toFixed(2) : result.toFixed(0);
            return (minusCondition ? '-' : '') + result + si[exp - 1];
        };
    })
    .filter('EUMoneyFormat', function () {
        return function (value, isMoneyFormat) {
            if (isMoneyFormat !== true) return value;
            return value
                .split('.')
                .map(function (item) {
                    return item.replace(',', '.');
                })
                .join(',');
        };
    });
